import { render, staticRenderFns } from "./SelectControlPoint.vue?vue&type=template&id=71856dd3&scoped=true&"
import script from "./SelectControlPoint.vue?vue&type=script&lang=js&"
export * from "./SelectControlPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71856dd3",
  null
  
)

export default component.exports